import React from 'react';
import { gettext } from '@eb/i18n-ebspa';
import random from 'lodash/random';

import { Illustration } from '@eb/eds-illustration';

import SuperCropOneSvg from 'consumer-utils/resources/superCropOne';
import SuperCropTwoSvg from 'consumer-utils/resources/superCropTwo';
import SuperCropThreeSvg from 'consumer-utils/resources/superCropThree';

import './OrganizerArticleProfileImage.scss';

const ORGANIZER_IMAGE_DIAMETER = '80px';
const SUPER_CROPS = [
    <SuperCropOneSvg key="supercrop-one" />,
    <SuperCropTwoSvg key="supercrop-two" />,
    <SuperCropThreeSvg key="supercrop-three" />,
];

const OrganizerArticleProfileImage = ({ image, organizerName }) => {
    const randomSuperCropImage = SUPER_CROPS[random(0, 2)];

    let organizerImage = null;

    if (image) {
        organizerImage = (
            <img
                className="organizer-article-card__profile-image"
                src={image}
                width={ORGANIZER_IMAGE_DIAMETER}
                height={ORGANIZER_IMAGE_DIAMETER}
                alt={gettext(`${organizerName} profile image.`)}
            />
        );
    } else {
        organizerImage = (
            <div className="organizer-article-card__profile-image-placeholder">
                <Illustration
                    type={randomSuperCropImage}
                    width={ORGANIZER_IMAGE_DIAMETER}
                    height={ORGANIZER_IMAGE_DIAMETER}
                />
            </div>
        );
    }

    return (
        <div className="organizer-article-card__profile-image-container">
            {organizerImage}
        </div>
    );
};

export default OrganizerArticleProfileImage;
